<template>
    <div class="reports-section">
        <div class="reports-header">
            <h3>סיכום חודשי</h3>
            <p>תצוגה מרוכזת של נתוני החודש</p>
        </div>
        <div class="reports-body">
            <div class="static-box">
                <button>+</button>
            </div>
        </div>
    </div>
</template>

<script>
  import { db } from '../firebase';
  import firebase from "firebase/app";
import moment from 'moment';
import { ref } from 'vue';
export default {
    name: 'reports',
	data () {
    return {
		
    }
  },
  created() {
  },
  updated() {
  },
  methods:{




        
  }
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Heebo:wght@100;300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alef:wght@400;700&family=Huninn&family=Playpen+Sans+Hebrew:wght@100..800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bellefair&display=swap');

*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.reports-section{
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    padding: 1rem;
}
.reports-header{
    width: 100%;
}
.reports-header h3{
    font-weight: 500;
    color: #000;
    font-family:'Noto Sans Hebrew' ;
}
.reports-header p{
    color: #a7a7a7;
    font-family:'Noto Sans Hebrew' ;
    font-size: 14px;
}
.static-box{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    border: 1px solid #014342;
    padding: 1rem;
    border-radius: 5px;
    background-color: #014342;
}
.static-box button{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    background-color: #76E6B6;
    border: 0;
    font-size: 25px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/reports.vue